import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

export const enum HeaderHeight {
  Small = '4em',
  Large = '5.5em'
}

export const HeaderContainer = Styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  width: 100%;
  background: ${({ theme }) => theme.colorWhite};
  box-sizing: border-box;
  border-bottom: 1px solid ${({ theme }) => theme.colorSlate10};
  height: ${HeaderHeight.Small};

  ${media.large`
    height: ${HeaderHeight.Large};
  `}
`;
